import { encargoServices } from '@/api/financial/encargoServices'

export default {
  loadTable({ commit }, pageConfig) {
    return new Promise((resolve, reject) => encargoServices.loadTable(pageConfig).then(result => {
      commit('LOAD_LIST', result.data.content || result.data)
      resolve(result)
    }).catch(err => reject(err)))
  },
  insertNew({ commit }, data) {
    return encargoServices.insert(data).then(result => result).catch(error => error)
  },
  prepareToEdit({ commit }, data) {
    commit('PREPARE_TO_EDIT', data)
  },
  edit({ commit }, data) {
    return encargoServices.update(data.id, data).then(result => result).catch(error => error)
  },
  reset({ commit }) {
    commit('RESET')
  },
  delete({ commit }, id) {
    return encargoServices.delete(id).then(result => result).catch(error => error)
  },
}
